import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IndianRupee,
  BedDouble,
  MapPin,
  Ruler,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import CustomButton from "../../../../components/shared/CustomButton";
import FormBox from "../../modal/FormBox";

const locationPerPage = 6;

const LocationComponentsCard = ({ LocationData }) => {
  const heading = LocationData.taglineheading;
  const locationtag = LocationData.locationtag;
  const developers = LocationData.location;
  console.log("properties", developers);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentFormData, setCurrentFormData] = useState(null); // State to hold selected form data

  const [showForm, setShowForm] = useState(false);
  const totalPages = Math.ceil(developers.length / locationPerPage);

  // Slice developers based on the current page and developersPerPage
  const currentDevelopers = developers.slice(
    (currentPage - 1) * locationPerPage,
    currentPage * locationPerPage
  );

  const handleNext = () => {
    if (currentPage < Math.ceil(developers.length / locationPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };



  // Redirect function
  const redirect = (url) => {
    navigate(url); // Use navigate to redirect to the desired URL
  };

  // Form Open

  const handleOpenForm = (formdata) => {
    setCurrentFormData(formdata); // Set the selected form data
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setCurrentFormData(null); // Clear the form data on close
  };

  const openProject = (url) => {
    window.location.href = `${url}`;
  };
  return (
    <div className="w-full flex justify-center bg-[#001020] ">
      <div className="w-full flex gap-14 flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6 px-2 md:px-0 ">
        <div className=" flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className=" flex flex-col justify-center items-center  mb-10">
            <h2 className=" text-[24px] font-medium text-center text-[#c2c2c2] ">
              {heading}
            </h2>
            <h2 className="text-[16px] text-[#c2c2c2]">{locationtag}</h2>
          </div>
          {/* Responsive grid container for cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
            {currentDevelopers.map((developer, index) => (
              <div
                key={index}
                className="relative group  w-full max-w-[400px] overflow-hidden rounded-lg bg-[#f4f8ff]
                 border-gray-700 border"
                 onClick={() => handleOpenForm(developer.form)} 
              >
                <div className="p-3">
                  <img
                    src={developer.image}
                    alt={developer.name}
                    className="w-full h-[200px] xl:h-[220px] object-cover transition-all duration-300 rounded-md"
                  />
                </div>
                <div className="flex flex-col justify-between  md:px-3">
                  <div>
                    <h1 className="flex items-center justify-center text-black text-[18px] font-medium mt-2">
                      {developer.name}
                    </h1>
                  </div>
                  <div className="flex flex-col gap-0 p-2 max-h-[120px] ">
                    <div className="flex flex-wrap items-center justify-between">
                      <div className="flex gap-1 flex-1">
                        <IndianRupee className="text-[#374151]   font-extrabold w-[18px] h-[18px]" />
                        <p className="text-black text-[12px]">
                          {developer.price}
                        </p>
                      </div>
                      <div className="flex gap-1 flex-1">
                        <BedDouble className="text-[#374151]  font-extrabold w-[18px] h-[18px] mx-2" />
                        <p className="text-black text-[12px]">
                          {developer.bed}
                        </p>
                      </div>
                    </div>

                    <div className="flex justify-between">
                      <div className="flex gap-1 flex-1">
                        <MapPin className="text-[#374151]   font-extrabold w-[18px] h-[18px]" />
                        <p className="text-black text-[12px]">
                          {developer.location}
                        </p>
                      </div>
                      <div className="flex gap-1 flex-1">
                        <Ruler className="text-[#374151]   font-extrabold mx-2 w-[18px] h-[18px]" />
                        <p className="text-black text-[12px]">
                          {developer.size}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between md:px-2 pb-3  gap-3 ">
                    {/* <CustomButton size="20px"   tag="Enquire Now" />
          
                    <CustomButton size="20px" tag="Explore More" /> */}
                    <button
                     onClick={() => handleOpenForm(developer.form)} 
                      className=" 
                    bg-[#374151] text-white text-[14px] h-[35px] w-[140px] rounded-md"
                    >
                      Enquire Now
                    </button>
                    <button
                     onClick={() => handleOpenForm(developer.form)} 
                      className=" 
                    bg-[#374151] text-white text-[14px] h-[35px] w-[140px] rounded-md"
                    >
                      View More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Buttons */}
          <div className="mt-8 flex items-center gap-4">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className={`${
                currentPage === 1
                  ? "bg-gray-400 opacity-50 cursor-not-allowed"
                  : "bg-gray-700 hover:bg-gray-700"
              } text-white px-2 py-1 rounded-md`}
            >
              <ChevronLeft />
            </button>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className={`${
                currentPage === totalPages
                  ? "bg-gray-400 opacity-50 cursor-not-allowed"
                  : "bg-gray-700 hover:bg-gray-700"
              } text-white px-2 py-1 rounded-md`}
            >
              <ChevronRight />
            </button>
          </div>
        </div>

        {/* Pop up Form Start */}
        {showForm && currentFormData && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg p-6 shadow-lg relative w-full max-w-lg">
              <button
                onClick={handleCloseForm}
                className="absolute top-2 right-2 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
              >
                ✕
              </button>
              {/* Pass the selected form data */}
              <FormBox formdata={currentFormData} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default LocationComponentsCard;
